import Vue from 'vue';
import ContextMenuFix from '@/directives/contextMenuFix';

Vue.directive('context-menu-fix', ContextMenuFix);
